import React, { useState } from "react";
import logo from "../../assests/Logo/Mr .PDF.svg";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="navbar-container">
      <nav className="navbar">
        {/* Logo Space - Left empty for your asset */}
        <div className="navbar-logo">
          <a href="/" aria-label="Home">
            <img src={logo} alt="Mr. PDF Logo" />
          </a>
        </div>

        {/* Hamburger Icon for Mobile */}
        <button
          className={`hamburger ${isOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation"
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>

        {/* Navigation Links */}
        <ul className={`nav-links ${isOpen ? "active" : ""}`}>
          <li>
            <a href="/Allpage" onClick={toggleMenu}>
              All Tools
            </a>
          </li>
          {/* <li>
            <a href="#shipping-label" onClick={toggleMenu}>
              Shipping Label
            </a>
          </li> */}
          <li>
            <a href="/MergePDFTool" onClick={toggleMenu}>
              Merge PDF
            </a>
          </li>
          <li>
            <a href="/compress-pdf" onClick={toggleMenu}>
              Compress PDF
            </a>
          </li>
          <li>
            <a href="/about-us" onClick={toggleMenu}>
              About
            </a>
          </li>
          {/* <li>
            <a href="/contact" onClick={toggleMenu}>
              Contact
            </a>
          </li> */}
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;
